import { Header } from '../components/Header';
import { PageIntro } from '../components/PageIntro';
import { AboutSection } from '../components/AboutSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { CredentialsSection } from '../components/CredentialsSection';
import { FAQSection } from '../components/FAQSection';
import { Footer } from '../components/Footer';
export function AboutPage() {
  return (
    <>
      <Header />
      <PageIntro
        eyebrow="О компании"
        title="Независимость как принцип работы"
        description="ТОО «Audit Vector» — аудит и инвентаризация для промышленных и государственных заказчиков Казахстана."
      />
      <AboutSection />
      <CredentialsSection />
      <BenefitsSection />
      <FAQSection />
      <Footer />
    </>
  );
}
